// @ts-expect-error: non-ts file
import instrumentMethods from 'instrument-methods';

import type { Analytics } from 'src/modules/seek-jobs-analytics';

function logAnalytics(methodName: keyof Analytics, args: unknown[]) {
  if (typeof window !== 'undefined' && window.ANALYTICS_DEBUG) {
    // eslint-disable-next-line no-console
    console.log(`analytics.${methodName}()`, ...args);
  }
}

export function instrumentAnalytics(analytics: Analytics): void {
  instrumentMethods(analytics, { after: logAnalytics });
}
